import { render, staticRenderFns } from "./TinyMce.vue?vue&type=template&id=3c829438"
import script from "./TinyMce.vue?vue&type=script&lang=ts"
export * from "./TinyMce.vue?vue&type=script&lang=ts"
import style0 from "./TinyMce.vue?vue&type=style&index=0&id=3c829438&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports